export const IN_APP_LINK_HOME = 'homepage';
